var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 15.1666H3.33337C1.95337 15.1666 0.833374 14.0466 0.833374 12.6666V1.33325C0.833374 1.05992 1.06004 0.833252 1.33337 0.833252C1.60671 0.833252 1.83337 1.05992 1.83337 1.33325V12.6666C1.83337 13.4933 2.50671 14.1666 3.33337 14.1666H14.6667C14.94 14.1666 15.1667 14.3933 15.1667 14.6666C15.1667 14.9399 14.94 15.1666 14.6667 15.1666Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33326 11.8333C3.21992 11.8333 3.09992 11.7933 3.00659 11.7133C2.79992 11.5333 2.77326 11.22 2.95326 11.0066L6.01326 7.43329C6.34659 7.04663 6.82659 6.8133 7.33326 6.7933C7.83992 6.77996 8.33992 6.96662 8.69992 7.32662L9.33326 7.95996C9.49992 8.12663 9.71992 8.20663 9.95326 8.20663C10.1866 8.19996 10.3999 8.09329 10.5533 7.91329L13.6133 4.33997C13.7933 4.1333 14.1066 4.10662 14.3199 4.28662C14.5266 4.46662 14.5533 4.77996 14.3733 4.99329L11.3133 8.56663C10.9799 8.9533 10.4999 9.18663 9.99326 9.20663C9.48659 9.21996 8.98659 9.0333 8.62659 8.6733L7.99992 8.03996C7.83326 7.87329 7.61326 7.78663 7.37992 7.7933C7.14659 7.79996 6.93326 7.90663 6.77992 8.08663L3.71992 11.66C3.61326 11.7733 3.47326 11.8333 3.33326 11.8333Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.553148fd7b70024880ea4e657082e192.svg";
export { ForwardRef as ReactComponent };